import { ready } from "./utils.js";

//Landing pages: h1 fades in on load, h2/h3/.animation as soon as they are completely in view
function isScrolledIntoView(el) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.bottom <= window.innerHeight;
}

ready(function () {
  document.querySelectorAll("h1").forEach((el) => el.classList.add("visible"));

  window.addEventListener("scroll", function () {
    document.querySelectorAll("h2, h3, .animation").forEach((el) => {
      if (isScrolledIntoView(el)) {
        el.classList.add("visible");
      }
    });
  });
});
